import React from 'react';
import { Box} from '@mui/material';
import HeroSection from './components/HeroSection/HeroSection';
import AboutSection from './components/AboutSection/AboutSection';
import BookingSection from './components/BookingSection/BookingSection';
import TestimonialsSection from './components/TestimonialsSection/TestimonialsSection';
import FrequentlyAskedQuestionsSection from './components/FrequentlyAskedQuestionsSection/FrequentlyAskedQuestionsSection';
import ContactUsForm from '../shared/ContactUsForm/ContactUsForm';

const Home = () => {
  return (
    <Box>
      <HeroSection />
      <AboutSection />
      <BookingSection />
      <TestimonialsSection />
      <FrequentlyAskedQuestionsSection />
      <ContactUsForm />
    </Box>
  );
};

export default Home;

